module.exports = __webpack_public_path__ + "img/rar.f2e3362b.svg";